import { UserRole } from '../types';

/**
 * DISPLAY-ONLY role labels. The `UserRole` enum values double as the strings persisted in the DB
 * (e.g. 'Operating Partner', 'OP Manager'), so we must NOT change the enum itself. Instead we render
 * roles through this map: 'Operating Partner' -> 'Submitter', 'OP Manager' -> 'Manager'. Behavior,
 * authorization and API payloads keep using the raw enum values; only the on-screen wording changes.
 *
 * Per-workflow timeline labels are handled separately (Workflow.stageLabels); this map is the generic
 * fallback for anywhere a bare user role is shown (chips, table cells, headers, toasts).
 */
export const ROLE_LABEL: Record<UserRole, string> = {
  [UserRole.OPERATING_PARTNER]: 'Submitter',
  [UserRole.OP_MANAGER]: 'Manager',
  [UserRole.PROXY]: 'Proxy',
  [UserRole.DEAL_OWNER]: 'Deal Owner',
  [UserRole.ACCOUNTANT]: 'Accountant',
  [UserRole.ADMIN]: 'Admin',
};

/** Human label for a user role. Falls back to the raw value for unknown/undefined input. */
export function roleLabel(role?: UserRole | string | null): string {
  if (!role) {
    return '';
  }
  return ROLE_LABEL[role as UserRole] ?? String(role);
}
